(() => {
  const T = window.INASSU_T || { dh: 'درهم', save: 'وفر' };
  const main = document.querySelector("[data-gallery-main]");
  const thumbs = [...document.querySelectorAll("[data-gallery-thumb]")];
  thumbs.forEach((thumb) => thumb.addEventListener("click", () => {
    if (!main) return;
    main.src = thumb.dataset.galleryThumb;
    main.removeAttribute("srcset");
    thumbs.forEach((item) => item.classList.toggle("active", item === thumb));
  }));

  const price = document.querySelector("[data-price]");
  const compare = document.querySelector("[data-compare]");
  const stickyPrice = document.querySelector("[data-sticky-price]");
  document.querySelectorAll("[data-offer]").forEach((offer) => offer.addEventListener("change", () => {
    if (offer.dataset.image && main) { main.src = offer.dataset.image; main.removeAttribute("srcset"); }
    const text = `${offer.dataset.price} ${T.dh}`;
    if (price) price.textContent = text;
    if (stickyPrice) stickyPrice.textContent = text;
    if (compare) {
      compare.hidden = !offer.dataset.compare;
      compare.textContent = `${offer.dataset.compare} ${T.dh}`;
    }
  }));

  // Two-option products (colour/model + "العرض" pack): pick the variant matching both choices.
  const variantsEl = document.querySelector("[data-variants]");
  if (variantsEl) {
    const variants = JSON.parse(variantsEl.textContent);
    const idInput = document.querySelector("[data-variant-id]");
    const dh = (cents) => `${Math.round(cents / 100)} ${T.dh}`;
    const chosen = (i) => document.querySelector(`[data-opt="${i}"]:checked`)?.value;
    const update = (changed) => {
      const v0 = chosen(0), v1 = chosen(1);
      const variant = variants.find((v) => v.option1 === v0 && v.option2 === v1);
      if (!variant) return;
      idInput.value = variant.id;
      if (price) price.textContent = dh(variant.price);
      if (stickyPrice) stickyPrice.textContent = dh(variant.price);
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = dh(variant.compare_at_price || 0);
      }
      if (changed === "0" && variant.featured_image && main) { main.src = variant.featured_image.src; main.removeAttribute("srcset"); }
      document.querySelectorAll('[data-opt="1"]').forEach((input, i) => {
        const pack = variants.find((v) => v.option1 === v0 && v.option2 === input.value);
        if (!pack) return;
        const p = document.querySelector(`[data-pack-price="${i}"]`);
        const c = document.querySelector(`[data-pack-compare="${i}"]`);
        const s = document.querySelector(`[data-pack-save="${i}"]`);
        const discounted = pack.compare_at_price > pack.price;
        if (p) p.textContent = dh(pack.price);
        if (c) c.textContent = discounted ? Math.round(pack.compare_at_price / 100) : "";
        if (s) { s.hidden = !discounted; s.textContent = `${T.save} ${dh(pack.compare_at_price - pack.price)}`; }
        const ship = document.querySelector(`[data-pack-ship="${i}"]`);
        if (ship) ship.hidden = pack.price < 15000;
      });
    };
    document.querySelectorAll("[data-opt]").forEach((input) => input.addEventListener("change", () => update(input.dataset.opt)));
  }

  const sticky = document.querySelector("[data-sticky-order]");
  const form = document.getElementById("ProductForm");

  // The order button opens the EasySell COD form; if EasySell isn't loaded, fall back to Shopify checkout.
  const orderButton = document.querySelector("[data-order-button]");
  orderButton?.addEventListener("click", () => {
    setTimeout(() => {
      const modal = document.getElementById("easysell-modal");
      if (!window.ES_CONFIG || !modal) form?.submit();
    }, 400);
  });
  document.querySelector("[data-sticky-button]")?.addEventListener("click", () => orderButton?.click());
  if (sticky && form && "IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle("visible", !entry.isIntersecting)).observe(form);
  }
})();
